import { gql } from '@zenbusiness/application-commons-graphql';

// Define query get list cards
export const GET_ORDER_TASK_STATUS = gql`
  query OrderTasks($businessEntityUuid: UUID!) {
    orderTasksByBusinessEntity(businessEntityUuid: $businessEntityUuid) {
      status
      type
      createdAt
    }
  }
`;
